import React from 'react';
import InfluencerTable from '../components/InfluencerTable';

export default function Influencers() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-4xl font-bold text-gray-900">Influencer Database</h1>
      </div>
      
      <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-100">
        <InfluencerTable />
      </div>
    </div>
  );
}